export const ADD_PRODUCT_ID = 'add-product';
export const ADD_RECIPE_ID = 'add-recipe';
